import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Dropdown} from '@homeaway/react-dropdown';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__16} from '@homeaway/svg-defs';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import throttle from 'lodash.throttle';
import classNames from 'classnames';

import MobileNav from './MobileNav';

import {HomeRouteContext} from 'utils/context';

import './Header.less';

export class HeaderComponent extends Component {
    constructor(props) {
        super(props);

        this.attachListeners();
        this.throttledHandler = throttle(this.scrollHandler, 500);

        this.state = {
            scrolled: false,
            currentPath: '',
        };
    }

    componentDidMount() {
        this.attachListeners();
    }

    componentWillUnmount() {
        this.detachListeners();
    }

    static contextType = HomeRouteContext;

    attachListeners = () => {
        /* istanbul ignore else */
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.throttledHandler);
        }
    };

    detachListeners = () => {
        /* istanbul ignore else */
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', this.throttledHandler);
        }
    };

    onExpandMenu = () => {
        document.body.classList.toggle('nav-menu-open');
    };

    scrollHandler = () => {
        if (window.pageYOffset > 0) {
            this.setState({scrolled: true});
        } else {
            this.setState({scrolled: false});
        }
    };

    render() {
        const {
            translations = {},
            isMobile,
            homeRoute,
            logo,
            children,
            partition,
        } = this.props;
        const fixedClasses = classNames('Header--fixed', {
            'Header--shadow': this.state.scrolled,
        });

        return (
            <header className="Header">
                <nav className={fixedClasses}>
                    <div className="Header__logo">
                        <a href={logo.link}>
                            <img src={logo.image} alt={logo.text} />
                        </a>
                    </div>

                    {!isMobile && (
                        <ul className="Header__middle-items">
                            {!partition && (
                                <li className="Header__middle-item">
                                    <Link
                                        to={homeRoute}
                                        className="Header__home-link"
                                    >
                                        {translations.home}
                                    </Link>
                                </li>
                            )}
                            <li className="Header__middle-item">
                                <Dropdown
                                    label={translations.categories}
                                    id="header_dropdown"
                                    dropdownRight
                                    onDropdownShow={this.onExpandMenu}
                                    onDropdownHide={this.onExpandMenu}
                                    customToggle={
                                        <button className="Header__dropdown btn">
                                            {translations.categories}
                                            <SVGIcon
                                                inline
                                                className="Header__dropdown-svg"
                                                markup={CHEVRON_DOWN__16}
                                            />
                                        </button>
                                    }
                                >
                                    {children}
                                </Dropdown>
                            </li>
                            <li className="Header__button hidden-xs hidden-sm">
                                <a className="btn btn-default" href={logo.link}>
                                    {translations.headerButton}
                                </a>
                            </li>
                        </ul>
                    )}
                    {isMobile && (
                        <MobileNav
                            translations={translations}
                            homeRoute={homeRoute}
                        >
                            {children}
                        </MobileNav>
                    )}
                </nav>
            </header>
        );
    }
}

export default determineIfMobile(HeaderComponent);
